import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
interface CodeBlockProps {
  code: string;
  language: string;
  title?: string;
}
export function CodeBlock({
  code,
  language,
  title
}: CodeBlockProps) {
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <div className="my-6 rounded-xl overflow-hidden border border-gray-200 shadow-sm" data-id="element-156">
      {title && <div className="bg-[#F8FAFC] px-4 py-3 border-b border-gray-200 flex justify-between items-center" data-id="element-157">
          <span className="text-sm font-semibold text-gray-700" data-id="element-158">{title}</span>
        </div>}
      <div className="relative bg-[#0F172A] group" data-id="element-159">
        <div className="absolute right-3 top-3 flex items-center space-x-3" data-id="element-160">
          <span className="text-xs text-gray-400 font-mono" data-id="element-161">{language}</span>
          <button onClick={handleCopy} className="p-1.5 rounded-md bg-white/10 text-gray-300 hover:text-white hover:bg-white/20 transition-colors focus:outline-none focus:ring-2 focus:ring-white/30" aria-label="Copy code" title="Copy to clipboard" data-id="element-162">
            {copied ? <Check className="w-4 h-4 text-green-400" data-id="element-163" /> : <Copy className="w-4 h-4" data-id="element-164" />}
          </button>
        </div>
        <pre className="p-5 pt-12 overflow-x-auto text-sm font-mono text-gray-300 leading-relaxed" data-id="element-165">
          <code data-id="element-166">{code}</code>
        </pre>
      </div>
    </div>;
}